/* ══════════════════════════════════════════════════════════
   AZN MILANO — Global Utilities (Shopify Dawn adaptation)
   Design-only helpers ported from the static HTML site.
   ══════════════════════════════════════════════════════════ */

(() => {
  const AZN = {
    // ── LOADER ──
    // Fades out #loader element once the page is ready.
    initLoader() {
      const loader = document.getElementById('loader');
      if (!loader) return;
      const bar = loader.querySelector('.loader-bar span');
      let w = 0;
      const iv = setInterval(() => {
        w += Math.random() * 18 + 6;
        if (w >= 100) {
          w = 100;
          clearInterval(iv);
          setTimeout(() => loader.classList.add('hidden'), 350);
        }
        if (bar) bar.style.width = `${w}%`;
      }, 120);
    },

    // ── NAVBAR ──
    // Adds .scrolled to Dawn's header wrapper when user scrolls past 50px.
    initNavbar() {
      const nav =
        document.querySelector('.header-wrapper') ||
        document.querySelector('header.header') ||
        document.getElementById('navbar');
      if (!nav) return;
      const onScroll = () => {
        nav.classList.toggle('scrolled', window.scrollY > 50);
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    },

    // ── SCROLL ANIMATIONS (AOS) ──
    // Observes [data-aos] nodes and flips .is-visible when in viewport.
    initAOS() {
      const targets = document.querySelectorAll('[data-aos]');
      if (!targets.length) return;
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
      );
      targets.forEach((el) => observer.observe(el));
    },

    // ── BACK TO TOP ──
    // Toggles #btt visibility past 600px, smooth-scrolls to top on click.
    initBTT() {
      const btn = document.getElementById('btt');
      if (!btn) return;
      const onScroll = () => {
        btn.classList.toggle('show', window.scrollY > 600);
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },

    // ── COUNTDOWN ──
    // Reads ISO date from [data-countdown] and updates .cd-days/.cd-hours/.cd-minutes/.cd-seconds.
    initCountdown() {
      const hosts = document.querySelectorAll('[data-countdown-target]');
      if (!hosts.length) return;

      const pad = (n) => String(Math.max(0, n)).padStart(2, '0');

      const render = (host, target) => {
        const diff = target - Date.now();
        if (diff <= 0) {
          host.querySelectorAll('.cd-days, .cd-hours, .cd-minutes, .cd-seconds')
            .forEach((el) => (el.textContent = '00'));
          return false;
        }
        const d = Math.floor(diff / 864e5);
        const h = Math.floor((diff % 864e5) / 36e5);
        const m = Math.floor((diff % 36e5) / 6e4);
        const s = Math.floor((diff % 6e4) / 1e3);
        const setText = (sel, val) => {
          const el = host.querySelector(sel);
          if (el) el.textContent = pad(val);
        };
        setText('.cd-days', d);
        setText('.cd-hours', h);
        setText('.cd-minutes', m);
        setText('.cd-seconds', s);
        return true;
      };

      hosts.forEach((host) => {
        const iso = host.dataset.countdown;
        if (!iso) return;
        const target = new Date(iso).getTime();
        if (Number.isNaN(target)) return;
        if (!render(host, target)) return;
        const iv = setInterval(() => {
          if (!render(host, target)) clearInterval(iv);
        }, 1000);
      });
    },

    // ── INIT ──
    init() {
      this.initLoader();
      this.initNavbar();
      this.initAOS();
      this.initBTT();
      this.initCountdown();
    },
  };

  window.AZN = AZN;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => AZN.init());
  } else {
    AZN.init();
  }
})();
